import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { HttpServiceAccount } from "src/app/services/Authorization/http/http.service_Account";
import { Customer, CustomCategory, CustomerLazyOut, CustomerLazy, CustomerLazySearch } from "src/classes/Customers/Customer";
import { screenId } from "src/environments/environment";
import { Control } from "src/classes/Authorization/BusinessRole";
import { LazyLoadEvent, MessageService } from "primeng/api";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";
import { PopupItem } from "src/classes/Common/PopupItem";
import { Config } from "src/classes/Common/ConfigData";
import { Router } from '@angular/router';
import { DataView } from "primeng/dataview";
import { Menu } from "primeng/menu";
// import { SelectItem } from "primeng/api";
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { SmsForClient } from "src/classes/Automation/sms_setting";
import { NGXLogger } from "ngx-logger";
import { SetValid } from "src/classes/Common/SetValid";
import { CustomerIn } from "src/classes/Customers/CustCard_1";

@Component({
    selector: "app-clientbase",
    templateUrl: "./clientbase.component.html",
    styleUrls: ["./clientbase.component.css"],
    providers: [HttpServiceCustomer, HttpServiceAccount, HttpService1, MessageService],
})
export class ClientbaseComponent implements OnInit {
    controls: Control[];

    items: ExtendedMenuItem[];

    customers: Customer[];
    selected: Customer;
    // initialCustomers: Customer[];
    // totalCustomers: number;
    rows: number = 50;
    layoutType: string = "grid";
    state: "loading" | "loaded" | "noresults" | "noclients" = "loading";
    // sortOptions: SelectItem[];
    // sortOrder: number;
    // sortKey: string;
    // sortField: string;

    sexData: string[] = ["הכל", "לא מוגדר", "אישה", "גבר"];
    customClassificationData: string[] = ["הכל", "יום הולדת החודש", "לקוח עם חוב"];
    customCategories: CustomCategory[];

    sexOption: string = "הכל";
    classificationOption: string = "הכל";
    categoryOption: string = "הכל";

    config: Config = new Config();

    // isClickedAddBeforeLoaded: boolean = false;

    customerin: CustomerIn = new CustomerIn();
    filterValue: string = "";

    openedMenu: Menu;
    isCardMenuOpened: boolean = false;
    isDeletingCardModalVisible: boolean = false;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    sms: SmsForClient = new SmsForClient();
    receivedsms: SmsForClient = new SmsForClient();
    isDialogVisible: boolean = false;
    isDialogErrorVisible: boolean = false;
    currentSmsWriter: Customer;
    smsText: string = "";
    // done: boolean;

    @ViewChild("dataView", { static: false }) dataView: DataView;
    @ViewChild("smsInput", { static: false }) smsInput: ElementRef<HTMLInputElement>;
    receivedvalid: SetValid = new SetValid();

    // Lazy loading
    totalRecords: number = 0;
    totalRecordsAll: number = 0;
    // isLazyLoading: boolean = false;
    customerLazy: CustomerLazy = new CustomerLazy();
    customerLazyOut: CustomerLazyOut = new CustomerLazyOut();
    customerLazySearch: CustomerLazySearch = new CustomerLazySearch();
    lazyLoadParams: LazyLoadEvent;
    filterTimeout: ReturnType<typeof setTimeout> | null = null;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private httpServiceAccount: HttpServiceAccount,
        private router: Router,
        private httpService1: HttpService1,
        private messageService: MessageService,
        private logger: NGXLogger
    ) { }

    ngOnInit() {
        // this.sortOptions = [
        //     { label: "Sex", value: "sex" },
        //     { label: "FullName", value: "fl" },
        // ];
        // this.logger.info("ClientBase init ...");

        // Enable lazy loading
        // this.isLazyLoading = true;

        // Get business configuration
        this.httpServiceCustomer.getConfig()
            .subscribe((data: Config) => {
                this.config = data;
                console.log("BusinessID:" + this.config.remotebusid);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + " , error: " + error.message);
            });

        // Get the list of control states
        this.httpServiceAccount.getControlsByScreen({ screen_id: screenId.Customers.clientbase })
            .subscribe((res: [Control]) => {
                this.controls = res;

                // Get the list of items in popup
                this.httpServiceCustomer.getItemsMenuByScreen({ screen_id: screenId.Customers.clientbase })
                    .subscribe((res: [PopupItem]) => {
                        let m: ExtendedMenuItem[] = [];
                        res.forEach(item => {
                            const menuItem: ExtendedMenuItem = {
                                label: item.mn_menuitem_title,
                                icon: item.mn_icon.split(".svg")[0],
                                command: () => this.menuItemCommand(item.mn_order_id),
                                menu_Id: 0,
                                disabled: item.cb_id_disable != -1 ? this.isDisabled(item.cb_id_disable) : false,
                            };

                            m.push(menuItem);
                        });

                        this.items = m;
                    }, error => {
                        console.log(error);
                        this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                    });
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get the list of customers
        // this.httpServiceCustomer.getCustomers()
        //     .subscribe((data: Customer[]) => {
        //         this.customers = [...data];
        //         this.initialCustomers = [...data];

        //         this.totalCustomers = this.customers.length;

        //         console.log("Count of customers: " + this.totalCustomers);

        //         // Set one of the states when the list is loaded
        //         if (this.customers.length == 0) {
        //             this.state = "noclients";
        //         }
        //         else {
        //             this.state = "loaded";
        //         }

        //         // Set the phone numbers and the client's name with this number to sessionStorage to use them on another screen
        //         let phoneNumbersSet = {};
        //         let recommendersSet = [];
        //         for (let i = 0; i < this.customers.length; i++) {
        //             if (this.customers[i].pelephone) {
        //                 phoneNumbersSet[this.customers[i].pelephone] = this.customers[i].fl;
        //             }
        //             if (this.customers[i].customerId) {
        //                 recommendersSet[this.customers[i].customerId] = this.customers[i].fl;
        //             }
        //         }
        //         sessionStorage.setItem("phoneNumbersSet", JSON.stringify(phoneNumbersSet));
        //         sessionStorage.setItem("recommendersSet", JSON.stringify(recommendersSet));

        //         // if (this.isClickedAddBeforeLoaded) {
        //         //     this.addNewClient();
        //         // }
        //     }, error => {
        //         console.log(error);
        //         this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
        //     });

        // Get the list of categories for filtering
        this.httpServiceCustomer.getCustomCategories()
            .subscribe((data: CustomCategory[]) => {
                this.customCategories = data;
                this.customCategories.forEach((category: CustomCategory) => category.custCategoryName = category.custCategoryName.trim());
                console.log("Count of customcategories: " + this.customCategories.length);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    // Disable controls while loading data
    // isControlsDisabled(): boolean {
    //     return this.state == "loading";
    // }

    // Disable controls when clients have not been loaded
    isFiltersDisabled(): boolean {
        return this.state == "noclients";
    }

    onPageChange(): void {
        this.dataView.el.nativeElement.offsetParent.scrollTo({ top: 0 });
        this.state = "loading";
    }

    getClientImageSrc(customer: Customer): string {
        return !customer.imagePath ? "assets/img/client-avatar.png" : "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/clients/" + customer.customerId + "/" + customer.imagePath;
    }

    isVIPCustomer(customer: Customer): boolean {
        return customer.idOfCategory.includes('7');
    }

    getWhatsAppLink(customer: Customer): string {
        if (customer && customer.pelephone && customer.pelephone.length == 10) {
            return "https://wa.me/+972" + customer.pelephone.slice(1);
        }
    }

    // Check if the control with the given id is blurred for the user by his role
    isBlurred(id: number): boolean {
        if (this.controls) {
            let control = this.controls.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let blurryRole = control.cb_is_blurry_role;
            let userRole = sessionStorage.getItem("userRole");

            return +userRole < +blurryRole;
        }
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controls) {
            let control = this.controls.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }

    // Clear the image path if the client image was not loaded to set the default image
    clearImagePath(id: number): void {
        this.customers.find(x => x.customerId == id).imagePath = "";
    }

    // Filter the list of customers by selected parameters
    filterDataCustomers(): void {
        this.state = "loading";
        this.lazyLoadParams.first = 0;
        this.dataView.first = 0;

        this.loadCustomersLazyAll();

        // this.customers = this.initialCustomers;

        // if (this.sexOption !== "הכל") {
        //     const sexindex = this.sexData.indexOf(this.sexOption);
        //     this.customers = this.customers.filter((customer: Customer) => customer.sex === sexindex);
        // }

        // if (this.classificationOption !== "הכל") {
        //     const classificationindex = this.customClassificationData.indexOf(this.classificationOption);
        //     this.customers = this.customers.filter((customer: Customer) => customer.debt === classificationindex || customer.birthDay === classificationindex);
        // }

        // if (this.categoryOption !== "הכל") {
        //     //  was before reject filtering //const categoryindex = this.customCategories.map(category => category.custCategoryName).indexOf(this.categoryOption);
        //     const categoryIndex = this.customCategories.find((category: CustomCategory) => category.custCategoryName == this.categoryOption).custCategoryId;
        //     this.customers = this.customers.filter((customer: Customer) => customer.idOfCategory.includes(categoryIndex.toString()));
        // }

        // // Go to the first page and scroll up on filtering
        // this.dataView.first = 0;
        // this.dataView.el.nativeElement.offsetParent.scrollTo({ top: 0 });

        // // Set one of the states when the list is loaded
        // if (this.customers.length == 0) {
        //     this.state = "noresults";
        // }
        // else {
        //     this.state = "loaded";
        // }

        // console.log("Count of customers after filtering: " + this.customers.length);
    }

    // Filter the list of customers by entered value
    filterByInput(): void {
        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }

        this.state = "loading";
        this.lazyLoadParams.first = 0;
        this.dataView.first = 0;

        this.filterTimeout = setTimeout(() => {
            this.loadCustomersLazyAll();
        }, 300);


        //     this.customers = this.initialCustomers;

        //     Perform a search in a filtered dataset
        //     this.filterDataCustomers();

        //     let value = this.filterValue.toLowerCase();

        //     this.customers = this.customers.filter((client: Customer) => {
        //         if (client.fl) {
        //             if (client.fl.toLowerCase().includes(value)) {
        //                 return true;
        //             }
        //         }
        //         if (client.pelephone) {
        //             if (client.pelephone.toLowerCase().includes(value)) {
        //                 return true;
        //             }
        //         }
        //         if (client.comments) {
        //             if (client.comments.toLowerCase().includes(value)) {
        //                 return true;
        //             }
        //         }
        //         return false;
        //     });

        //     // Set one of the states when the list is loaded
        //     if (this.customers.length == 0) {
        //         this.state = "noresults";
        //     }
        //     else {
        //         this.state = "loaded";
        //     }
    }

    // Check if the customer list has been filtered by comparing the lenth of the customer list with the total number of customers  
    // isFiltered(): boolean {
    //     return this.totalCustomers !== this.customers.length;
    // }

    // Check if the customer list has been filtered
    isFilteredLazy(): boolean {
        return this.totalRecords !== this.totalRecordsAll;
    }

    // Create a new client
    addNewClient(): void {
        // const maxId: number = this.initialCustomers.length ? this.initialCustomers.reduce((accumulator, current) => {
        //     return accumulator.customerId > current.customerId ? accumulator : current;
        // }).customerId + 1 : 1;

        this.router.navigate(["clients", "editpersonal"], { queryParams: { isNewClient: true } });
    }

    // Toggle the popup menu and close the others
    toggleSubMenu(event: PointerEvent, menu: Menu, customer: Customer, isMobile: boolean): void {
        this.selected = customer;
        if (isMobile) {
            this.isCardMenuOpened = true;
        }
        else {
            menu.toggle(event);

            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }
            this.openedMenu = menu;
        }
    }

    onScroll(): void {
        if (this.openedMenu) {
            this.openedMenu.hide();
        }
    }

    // Commands for menu items by their id
    menuItemCommand(order_id: number): void {
        switch (order_id) {
            case 1: {
                //new event
                break;
            }
            case 2: {
                //cash
                break;
            }
            case 3: {
                //iTor
                break;
            }
            case 4: {
                //link
                break;
            }
            case 5: {
                //customer locator
                break;
            }
            case 6: {
                this.isCardMenuOpened = false;
                this.isDeletingCardModalVisible = true;
                //there should be a service call here to update the data in the database
                break;
            }
            default: {
                break;
            }
        }
    }

    deleteCustomerCard(): void {
        const index = this.customers.indexOf(this.selected);
        this.isDeletingCardModalVisible = false;
        /*         const firstArr = this.customers.slice(0, index);
                const secondArr = this.customers.slice(index + 1);
                this.customers = [...firstArr, ...secondArr];
         */
        //there should be a service call here to update the data in the database
        this.customerin.customer_id = this.selected.customerId;
        this.httpServiceCustomer.deleteCustCard(this.customerin)
            .subscribe((res: SetValid) => {
                this.receivedvalid = res;
                this.receivedvalid.answer = res.answer;

                if (this.receivedvalid.answer) {
                    console.log("Customer is deleted: " + this.receivedvalid.answer);
                    const firstArray: Customer[] = this.customers.slice(0, index);
                    const secondArray: Customer[] = this.customers.slice(index + 1);
                    this.customers = [...firstArray, ...secondArray];

                    this.totalRecords--;
                    this.totalRecordsAll--;

                    if (!this.totalRecords) {
                        this.state = "noresults";
                    }

                    if (!this.totalRecordsAll) {
                        this.state = "noclients";
                    }

                    this.showMessage("success", "כרטיס הלקוח נמחק בהצלחה.");
                }
                else {
                    this.showMessage("fail", "מחיקת כרטיס לקוח נכשלה");
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        /*    this.isDeletingCardModalVisible = false;
           this.showMessage("success", "כרטיס הלקוח נמחק בהצלחה."); */
    }

    closeDeletingCardModal() {
        this.isDeletingCardModalVisible = false;
    }

    redirectToEditScreen(index: number): void {
        this.router.navigate(["clients", "custcardview", index]); //navigation to the customer data view screen
    }

    openDialog(customer: Customer): void {
        this.isDialogVisible = true;
        this.currentSmsWriter = customer;

        setTimeout(() => {
            this.smsInput.nativeElement.focus();
        }, 50);
    }

    hideDialog(isSubmited: boolean): void {
        if (isSubmited) {
            if (this.smsText.trim() != "") {
                this.isDialogErrorVisible = false;
                this.isDialogVisible = false;
                this.sendsmsClient(this.currentSmsWriter, this.smsText);
                this.smsText = "";
            }
            else {
                this.isDialogErrorVisible = true;
            }
        }
        else {
            this.isDialogErrorVisible = false;
            this.isDialogVisible = false;
            this.smsText = "";
        }
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }

    sendsmsClient(customer: Customer, smsText: string) {
        this.sms.businessEmail = sessionStorage.getItem("email");
        this.sms.customerId = customer.customerId;
        this.sms.pelephone = customer.pelephone;
        this.sms.txtMessage = smsText;

        //     this.httpService1.SendMessageClient(this.sms)
        //         .subscribe(
        //             (data: SmsForClient) => {
        //                 this.receivedsmssetApp = data; this.done = true;
        //             },
        //             error => console.log(error);
        //         );
        // }
        console.log(this.sms)
        this.httpService1.SendMessageClient(this.sms)
            .then((res: SmsForClient) => {
                this.receivedsms = res;
                console.log(this.receivedsms);
                // this.receivedsms = res.responceMessage;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    // Lazy loading
    loadCustomersLazyAll(event?: LazyLoadEvent | undefined) {
        if (event) {
            this.lazyLoadParams = event;
        }

        if (this.sexOption !== "הכל") {
            const sexindex: number = this.sexData.indexOf(this.sexOption);
            this.customerLazySearch.sex = sexindex;
        }
        else {
            this.customerLazySearch.sex = 0;
        }

        if (this.classificationOption !== "הכל") {
            const classificationindex: number = this.customClassificationData.indexOf(this.classificationOption);
            this.customerLazySearch.classification = classificationindex;
        }
        else {
            this.customerLazySearch.classification = 0;
        }

        if (this.categoryOption !== "הכל") {
            const categoryIndex: number = this.customCategories.find((category: CustomCategory) => category.custCategoryName == this.categoryOption).custCategoryId;
            this.customerLazySearch.category = categoryIndex;
        }
        else {
            this.customerLazySearch.category = 0;
        }

        this.customerLazySearch.search = this.filterValue.toLowerCase();

        if (this.filterValue.length < 2
            && this.customerLazySearch.sex === 0
            && this.customerLazySearch.classification === 0
            && this.customerLazySearch.category === 0) {
            this.loadCustomersLazy(this.lazyLoadParams);
        }
        else {
            this.loadCustomersLazySearch(this.lazyLoadParams);
        }
    }

    loadCustomersLazy(event: LazyLoadEvent) {
        // this.isLazyLoading = true;

        this.customerLazy.page = event.first / event.rows;
        this.customerLazy.size = event.rows;
        this.customerLazy.sortField = event.sortField;
        this.customerLazy.sortOrder = event.sortOrder;

        // setTimeout(() => {
        this.httpServiceCustomer.getCustomersLazy(this.customerLazy)
            .then((response: CustomerLazyOut) => {
                this.customerLazyOut = response;

                this.totalRecordsAll = this.customerLazyOut.totalCount;
                this.totalRecords = this.customerLazyOut.totalCount;

                this.customers = [...this.customerLazyOut.items];
                // this.initialCustomers = [...this.customerLazyOut.items];
                // this.totalCustomers = this.customers.length;

                console.log("Count of customers: " + this.customers.length);

                // Set one of the states when the list is loaded
                if (!this.totalRecords) {
                    this.state = "noclients";
                }
                else {
                    this.state = "loaded";
                }

                // Set the phone numbers and the client's name with this number to sessionStorage to use them on another screen
                // let phoneNumbersSet = {};
                // let recommendersSet = [];
                // for (let i = 0; i < this.customers.length; i++) {
                //     if (this.customers[i].pelephone) {
                //         phoneNumbersSet[this.customers[i].pelephone] = this.customers[i].fl;
                //     }
                //     if (this.customers[i].customerId) {
                //         recommendersSet[this.customers[i].customerId] = this.customers[i].fl;
                //     }
                // }
                // sessionStorage.setItem("phoneNumbersSet", JSON.stringify(phoneNumbersSet));
                // sessionStorage.setItem("recommendersSet", JSON.stringify(recommendersSet));

                // this.isLazyLoading = false;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
        // }, 1000);
    }

    loadCustomersLazySearch(event: LazyLoadEvent) {
        // this.isLazyLoading = true;

        this.customerLazySearch.page = event.first / event.rows;
        this.customerLazySearch.size = event.rows;
        this.customerLazySearch.sortField = event.sortField;
        this.customerLazySearch.sortOrder = event.sortOrder;

        // if (this.sexOption !== "הכל") {
        //     const sexindex = this.sexData.indexOf(this.sexOption);
        //     this.customerLazySearch.sex = sexindex;
        // }
        // else {
        //     this.customerLazySearch.sex = 0;
        // }

        // if (this.classificationOption !== "הכל") {
        //     const classificationindex = this.customClassificationData.indexOf(this.classificationOption);
        //     this.customerLazySearch.classification = classificationindex;
        // }
        // else {
        //     this.customerLazySearch.classification = 0;
        // }

        // if (this.categoryOption !== "הכל") {
        //     const categoryIndex = this.customCategories.find((category: CustomCategory) => category.custCategoryName == this.categoryOption).custCategoryId;
        //     this.customerLazySearch.category = categoryIndex;
        // }
        // else {
        //     this.customerLazySearch.category = 0;
        // }

        // this.customerLazySearch.search = this.filterValue.toLowerCase();

        // if (this.filterValue.length < 3
        //     && this.customerLazySearch.sex === 0
        //     && this.customerLazySearch.classification === 0
        //     && this.customerLazySearch.category === 0) {
        //     this.loadCustomersLazy(this.myevent);
        // }

        // setTimeout(() => {
        this.httpServiceCustomer.getCustomersLazySearch(this.customerLazySearch)
            .subscribe((response: CustomerLazyOut) => {
                this.customerLazyOut = response;

                this.totalRecords = this.customerLazyOut.totalCount;

                this.customers = [...this.customerLazyOut.items];
                // this.initialCustomers = [...this.customerLazyOut.items];
                // this.totalCustomers = this.customers.length;

                console.log("Count of customers: " + this.customers.length);

                // Set one of the states when the list is loaded
                if (!this.totalRecords) {
                    this.state = "noresults";
                }
                else {
                    this.state = "loaded";
                }

                // Set the phone numbers and the client's name with this number to sessionStorage to use them on another screen
                // let phoneNumbersSet = {};
                // let recommendersSet = [];
                // for (let i = 0; i < this.customers.length; i++) {
                //     if (this.customers[i].pelephone) {
                //         phoneNumbersSet[this.customers[i].pelephone] = this.customers[i].fl;
                //     }
                //     if (this.customers[i].customerId) {
                //         recommendersSet[this.customers[i].customerId] = this.customers[i].fl;
                //     }
                // }
                // sessionStorage.setItem("phoneNumbersSet", JSON.stringify(phoneNumbersSet));
                // sessionStorage.setItem("recommendersSet", JSON.stringify(recommendersSet));
                // Filter customers list
                // if (this.customerLazySearch.sex != 0
                //     || this.customerLazySearch.classification != 0
                //     || this.customerLazySearch.category != 0) {
                //     this.filterDataCustomers();
                // }

                // this.isLazyLoading = false;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
        // }, 1000);
    }
}
